import React, { useEffect, useState } from 'react';
import './Compagnia.css';

export default function Compagnia({ data = {}, setData }) {
  const [companies, setCompanies] = useState([]);
  const [ispettorati, setIspettorati] = useState([]);
  const [liquidatori, setLiquidatori] = useState([]);
  const [newCompany, setNewCompany] = useState('');
  const [newReferent, setNewReferent] = useState({ ruolo: 'Ispettorato', nome: '', telefono: '' });
  const [error, setError] = useState('');
  const companyId = data.compagniaId || '';
  const details = data.datiCompagnia || {};

  const refreshCompanies = async () => {
    const response = await fetch('/api/compagnie-assicurative');
    if (!response.ok) throw new Error('Elenco compagnie non disponibile');
    setCompanies(await response.json());
  };
  useEffect(() => { refreshCompanies().catch(e => setError(e.message)); }, []);
  useEffect(() => {
    if (!companyId) { setIspettorati([]); setLiquidatori([]); return; }
    Promise.all(['Ispettorato', 'Liquidatore'].map(ruolo =>
      fetch(`/api/compagnie-assicurative/${companyId}/referenti?ruolo=${ruolo}`).then(response => {
        if (!response.ok) throw new Error('Referenti non disponibili');
        return response.json();
      })
    )).then(([offices, people]) => { setIspettorati(offices); setLiquidatori(people); setError(''); })
      .catch(e => setError(e.message));
  }, [companyId]);

  const updateDetail = (key, value) => setData(previous => ({ ...previous,
    datiCompagnia: { ...previous.datiCompagnia, [key]: value }
  }));
  const chooseCompany = (value, createdName) => setData(previous => ({ ...previous, compagniaId: value ? Number(value) : null,
    nomeCompagnia: createdName || companies.find(company => String(company.id) === String(value))?.nome || '',
    datiCompagnia: { ...previous.datiCompagnia, ispettoratoId: null, liquidatoreId: null }
  }));
  const addCompany = async event => {
    event.preventDefault(); setError('');
    try {
      const response = await fetch('/api/contatti', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tipo: 'Assicurazione', tipo_soggetto: 'azienda', nome: newCompany.trim() }) });
      if (!response.ok) throw new Error('Compagnia non aggiunta');
      const created = await response.json();
      const detail = await fetch(`/api/contatti/${created.id}`).then(result => result.json());
      await refreshCompanies();
      chooseCompany(detail.compagnia_id, detail.nome);
      setNewCompany('');
    } catch (e) { setError(e.message); }
  };
  const addReferent = async event => {
    event.preventDefault(); setError('');
    try {
      const response = await fetch(`/api/compagnie-assicurative/${companyId}/referenti`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(newReferent)
      });
      if (!response.ok) throw new Error('Referente non aggiunto');
      const created = await response.json();
      if (newReferent.ruolo === 'Ispettorato') { setIspettorati(previous => [...previous, created]); updateDetail('ispettoratoId', created.id); }
      else { setLiquidatori(previous => [...previous, created]); updateDetail('liquidatoreId', created.id); }
      setNewReferent({ ruolo: 'Ispettorato', nome: '', telefono: '' });
    } catch (e) { setError(e.message); }
  };

  return <section className="dati-sinistro-container">
    <div className="box">
      <h2>Compagnia risarcitoria</h2>
      <label>Compagnia <select value={companyId} onChange={event => chooseCompany(event.target.value)}>
        <option value="">Seleziona una compagnia</option>
        {companies.map(company => <option key={company.id} value={company.id}>{company.nome}</option>)}
      </select></label>
      <form onSubmit={addCompany}>
        <label>Nuova compagnia <input value={newCompany} onChange={event => setNewCompany(event.target.value)} maxLength={200} required /></label>{' '}
        <button type="submit">Aggiungi compagnia</button>
      </form>
      {companyId && <>
        <label>Numero sinistro <input value={details.numeroSinistro || ''} onChange={event => updateDetail('numeroSinistro', event.target.value)} /></label>
        <div><label>Ispettorato <select value={details.ispettoratoId || ''} onChange={event => updateDetail('ispettoratoId', event.target.value ? Number(event.target.value) : null)}>
          <option value="">Seleziona un ispettorato</option>
          {ispettorati.map(item => <option key={item.id} value={item.id}>{item.nome}</option>)}
        </select></label></div>
        <div><label>Liquidatore <select value={details.liquidatoreId || ''} onChange={event => updateDetail('liquidatoreId', event.target.value ? Number(event.target.value) : null)}>
          <option value="">Seleziona un liquidatore</option>
          {liquidatori.map(item => <option key={item.id} value={item.id}>{item.nome}{item.telefono ? ` (${item.telefono})` : ''}</option>)}
        </select></label></div>
        <form onSubmit={addReferent}>
          <h3>Aggiungi referente alla compagnia</h3>
          <select aria-label="Tipo referente" value={newReferent.ruolo} onChange={event => setNewReferent(previous => ({ ...previous, ruolo: event.target.value }))}>
            <option>Ispettorato</option><option>Liquidatore</option>
          </select>{' '}
          <input aria-label="Nome referente" placeholder="Nome" required maxLength={200} value={newReferent.nome} onChange={event => setNewReferent(previous => ({ ...previous, nome: event.target.value }))} />{' '}
          <input aria-label="Telefono referente" placeholder="Telefono" maxLength={80} value={newReferent.telefono} onChange={event => setNewReferent(previous => ({ ...previous, telefono: event.target.value }))} />{' '}
          <button type="submit">Aggiungi</button>
        </form>
      </>}
      {error && <p role="alert">{error}</p>}
      <p>Per conservare le modifiche alla pratica, usa «Salva» nella scheda.</p>
    </div>
  </section>;
}
